import type { RegistryState } from '../../data/types';
import type { RegistryAction } from '../actions';
import { holderName, today, updateHolder, withAudit } from '../helpers';

type Handler<T extends RegistryAction['type']> = (
  state: RegistryState,
  action: Extract<RegistryAction, { type: T }>,
) => RegistryState;

export const completeTask: Handler<'TASK_COMPLETE'> = (state, action) => {
  const task = state.tasks.find((item) => item.id === action.id);
  if (!task) return state;
  let next: RegistryState = {
    ...state,
    tasks: state.tasks.map((item) => (item.id === action.id ? { ...item, status: 'DONE' } : item)),
  };
  if (task.kind === 'QUOTE_TFN') {
    next = updateHolder(next, task.holderId, () => ({
      tfnStatus: 'QUOTED',
      tfnLast3: (action.value ?? '000').slice(-3),
    }));
  }
  if (task.kind === 'RENEW_WHOLESALE') {
    next = updateHolder(next, task.holderId, (holder) => ({
      wholesale: {
        basis: 'ACCOUNTANT_CERTIFICATE',
        issuedAt: today,
        expiresAt: '2028-10-16',
        issuer: holder.wholesale?.issuer ?? 'Uploaded by investor',
      },
    }));
    next = {
      ...next,
      kycCases: next.kycCases.map((item) =>
        item.holderId === task.holderId && item.type === 'WHOLESALE_EXPIRING'
          ? { ...item, status: 'CLEARED', resolution: 'New certificate uploaded by investor' }
          : item,
      ),
    };
  }
  if (task.kind === 'CONFIRM_BANK') {
    next = updateHolder(next, task.holderId, (holder) => ({
      bank: {
        ...holder.bank,
        verified: true,
        accountNumber: action.value ? action.value.replace(/\s/g, '') : holder.bank.accountNumber,
      },
    }));
    next = {
      ...next,
      paymentExceptions: next.paymentExceptions.map((item) =>
        item.id === task.refId ? { ...item, status: 'REISSUED', resolvedAt: today } : item,
      ),
    };
  }
  if (task.kind === 'REFRESH_KYC') {
    next = updateHolder(next, task.holderId, () => ({
      kycStatus: 'VERIFIED',
      kycVerifiedAt: today,
      kycRefreshDue: '2029-10-16',
    }));
    next = {
      ...next,
      kycCases: next.kycCases.map((item) =>
        item.holderId === task.holderId && item.type === 'PERIODIC_REFRESH'
          ? { ...item, status: 'CLEARED', resolution: 'Re-verified by investor (GreenID)' }
          : item,
      ),
    };
  }
  return withAudit(
    next,
    'Investor task completed',
    task.title,
    holderName(state, task.holderId),
    'Investor portal',
  );
};
